import Service from "./Service"

class PayrollService extends Service {

    getPayrolls = (queryParams, year, month) => this.getWithParams(`/payrolls/year/${year}/month/${month}`, queryParams)

    getPayrollOfUser = (userId, year, month) => this.get(`/payrolls/${userId}/year/${year}/month/${month}`)

    getSalaryDetails = (queryParams) => this.getWithParams("/salary-details", queryParams)

    getUnpaidSalariesCount = () => this.get("/payrolls/unpaid")

    saveSalaryDetails = (requestBody) => this.post("/salary-details", requestBody)
}

const payrollService = new PayrollService()
export default payrollService